export const checkForWorkspaceStorageLimitError = (error) => {
    const error_code = error.response?.data?.errors?.[0]?.code;
    const direct_error = error.response?.data.error;

    if (error_code === "storage_limit_exceeded" || direct_error === "storage_limit_exceeded") {
        return true
    }
};
